<template>
  <ModuleSection title="对账单下载" class="download-bill-page">
    <!-- 查询表单 -->
    <el-form
      ref="queryForm"
      :model="formData"
      :rules="rules"
      label-position="left"
      class="download-bill-query">
      <el-row style="display: flex;">
        <el-col :span="12" style="margin-right: 40px;">
          <el-form-item
            :label="$t('账号')"
            prop="accountNo"
          >
            <el-select
              v-model="formData.accountNo"
              @change="changeAccount"
              :placeholder="$t('请选择')"
              style="width:100%">
              <el-option
                v-for="(value, key) in accountMap"
                :key="key"
                :label="value | translateFilter"
                :value="key" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('对账单日期')"
            prop="startDate"
          >
            <div style="display: flex; width: 100%;">
              <el-date-picker
                v-model="formData.startDate"
                :placeholder="$t('请选择')"
                style="flex: 1 1 0%;"
                value-format="yyyy-MM-dd"/>
                <el-form-item
                  prop="endDate"
                  style="flex: 1 1 0%; margin-left: 10px;">
                  <el-date-picker
                    v-model="formData.endDate"
                    :placeholder="$t('请选择')"
                    style="width: 100%;"
                    value-format="yyyy-MM-dd"/>
                </el-form-item>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 查询按钮 -->
    <el-row style="margin: 20px 0 40px;">
      <el-button class="btn140" type="primary" @click.stop="getTableData">{{ $t('查询对账单') }}</el-button>
    </el-row>
    <!-- 对账单明细 -->
    <div class="download-bill-detail" v-tloading="tableLoading">
      <div class="detail-title">
        <p>CBiBank Account Statement</p>
        <p>CBiBank 客户对账单</p>
      </div>
      <div class="detail-header">
        <div class="detail-header-item">
          <p>Currency：{{ currencyType }}</p>
          <p>{{ timeEn }}</p>
        </div>
        <div class="detail-header-item">
          <p>币种：{{ currencyTypeZh }}</p>
          <p>{{ timeZh }}</p>
        </div>
        <div class="split"></div>
        <div class="detail-header-item">
          <p>Account NO.：{{ accountNo }}</p>
        </div>
        <div class="detail-header-item">
          <p>账号：{{ accountNo }}</p>
        </div>
        <div class="split"></div>
        <div class="detail-header-item">
          <p>Account Name：{{ accountName }} {{ alias }}</p>
        </div>
        <div class="detail-header-item">
          <p>户名：{{ accountName }} {{ alias }}</p>
        </div>
        <div class="split"></div>
        <div class="detail-header-item">
          <p>Address：{{ addressEn }}</p>
        </div>
        <div class="detail-header-item">
          <p>联系地址：{{ addressZh }}</p>
        </div>
        <div class="split"></div>
      </div>

      <DataTable
        :data="tableData">
        <el-table-column label="Date">
          <el-table-column
            prop="transactionDate"
            label="日期"
            width="130px"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="Account NO.">
          <el-table-column
            prop="reciprocalAccountNo"
            width="150px"
            label="对方账号">
          </el-table-column>
        </el-table-column>
        <el-table-column label="Account Name"  width="150px">
          <el-table-column
            prop="reciprocalAccountName"
            width="150px"
            label="对方户名">
          </el-table-column>
        </el-table-column>
        <el-table-column label="Remittance Infomation"  width="120">
          <el-table-column
            prop="name"
            label="摘要">
          <template slot-scope="scope">
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
              <p>{{ scope.row.txTypeEn }}</p>
              <p>{{ scope.row.txType }}</p>
            </div>
          </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="Debit">
          <el-table-column
            prop="debitAmount"
            label="借方发生额"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="Credit">
          <el-table-column
            prop="creditAmount"
            label="贷方发生额"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="Balance">
          <el-table-column
            prop="balance"
            label="余额">
          </el-table-column>
        </el-table-column>
      </DataTable>
      <div class="bill-detail-bottom">
        <div class="bill-sign">
          <img v-if="formData.accountNo && signByAccountType === 1" src="@/assets/image/account/ebills_logo1.png" alt="" srcset="">
          <img v-if="formData.accountNo && signByAccountType === 2" src="@/assets/image/account/ebills_logo.png" alt="" srcset="">
        </div>
        <div class="bill-sign-right">
            <div class="page">
              Page: {{ pageNum }} of {{ totalPage }} {{ $t('页码') }}：{{ pageNum }} {{ $t('共') }} {{ totalPage }} {{ $t('页') }}
            </div>
            <div class="bill-detail-bottom-opt">
              <span>{{ $t('选择下载格式') }}:</span>
              <el-select
                v-model="downloadType"
                style="width: 120px"
                :placeholder="$t('请选择')">
                <el-option
                  v-for="(value, key) in downloadTypes"
                  :key="key"
                  :label="$t(value)"
                  :value="key" />
              </el-select>
              <span>{{ $t('版本') }}:</span>
              <el-select
                v-model="version"
                style="width: 120px"
                :placeholder="$t('请选择')">
                <el-option
                  v-for="(value, key) in versionList"
                  :key="key"
                  :label="$t(value)"
                  :value="key" />
              </el-select>
              <el-button @click="download" class="btn140" type="primary">{{ $t('下载回单') }}</el-button>
            </div>
          </div>
      </div>
    </div>
    <!-- 分页 -->
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageNum"
      :page-size.sync="pageSize"
      :total="total"
      layout="prev, pager, next, jumper" />
  </ModuleSection>
</template>

<script>
import ModuleSection from '@/components/container/ModuleSection'
// import { downloadBlob } from '@/utils/utils'
import downloadBillApi from '../../api/downloadBillApi'
import { downloadBlob } from '@/utils/utils'

export default {
  name: 'DownloadBillCache',
  components: {
    ModuleSection
  },
  data () {
    return {
      /* 查询表单 */
      accountMap: {},
      formData: {
        accountNo: '', // 账户
        startDate: '', // 开始日
        endDate: '', // 结束日
        currencyType: '' // 币种
      },
      // 下载格式
      downloadTypes: {
        pdf: 'pdf文件',
        excel: 'excel文件'
      },
      // 版本
      versionList: {
        EN_CN: '中英文',
        EN: 'English'
      },
      downloadType: 'excel',
      version: 'EN_CN',
      /* 查询表格 */
      tableData: [],
      tableLoading: false,
      searchSuccess: false,
      /* 分页 */
      pageNum: 1,
      pageSize: 10,
      total: 0,
      totalPage: 0,
      // 明细展示
      currencyType: '',
      currencyTypeZh: '',
      timeEn: '',
      timeZh: '',
      accountNo: '',
      accountName: '',
      addressEn: '',
      addressZh: '',
      alias: ''
    }
  },
  activated () {
    // 获取账户列表
    this.accountMap = this.$_params.getSessionAccountSelect_obj_includeBC('ALL', true, 0, 0)
    this.formData.accountNo = Object.keys(this.accountMap)[0]
    this.formData.currencyType = this.formData.accountNo.split('|')[1]
    // 查询类型
    this.queryType = this.$_params.GRB_QUERY_TYPE
    // 计算时间默认展示范围
    this.formData.endDate = this.$_format.getToday()
    // this.formData.endDate = '2020-03-01'
    this.formData.startDate = this.$_format.getLastDay(this.formData.endDate, 90)

    this.companyDetailManage()
    this.getTableData()
  },
  computed: {
    rules () {
      return {
        accountNo: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ],
        startDate: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ],
        endDate: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ]
      }
    },
    // 账户类型不同展示对应的印章
    signByAccountType () {
      const { accountNo } = this.formData.accountNo
      if (!accountNo) return 2

      const accountType = accountNo.split('|')[4]
      if (accountType === 'MSB' || accountType === 'MSBC' || accountType === 'MSBD') return 1
      return 2
    }
  },
  methods: {
    // 更换账户
    changeAccount (e) {
      this.formData.currencyType = e.split('|')[1]
    },
    // 获取联系地址
    async companyDetailManage () {
      return downloadBillApi.companyDetailManage({
        currentBusinessCode: 10700700,
        channel: 1103
      }).then(res => {
        if (res.ec === '0') {
          var ad = ['contactAddress', 'businessAddress', 'address']
          // 地址
          this.addressEn = res[ad[res.addressFlag]] || 'none'
          this.addressZh = res[ad[res.addressFlag]] || '无'
        }
      }).catch(err => {
        console.err(err)
      })
    },
    // 下载
    download () {
      // 判断是否在一年之内（365天）
      const flag = this.$_format.checkDate(this.formData.startDate, this.formData.endDate)
      if (flag !== true) {
        this.$warn(flag)
        return false
      }

      const startDate = this.formData.startDate.split('-').join('')
      const endDate = this.formData.endDate.split('-').join('')

      this.$talert('文件后台下载中，请耐心等待...', '系统提示', {
        confirmButtonText: '确定'
      })
      return downloadBillApi.downloadStatementsFiles({
        fileType: this.downloadType,
        languageType: this.version,
        accountNo: this.formData.accountNo.split('|')[0],
        currencyType: this.formData.accountNo.split('|')[1],
        startDate, // 开始日期
        endDate // 结束日期
      }).then(res => {
        if (res) {
          // 下载文件名改为自定义
          const month = new Date().getMonth() + 1
          const day = new Date().getDate()
          const time = new Date().getFullYear() + '' + (month > 9 ? month : ('0' + month)) + '' + (day > 9 ? day : ('0' + day))
          downloadBlob(res, {
            filename: 'CBiBank ' + this.$t('客户对账单') + time,
            ext: this.downloadType === 'pdf' ? this.downloadType : 'xlsx'
          })
          this.$success('下载成功')
        }
      }).catch(err => {
        this.tableLoading = false
        console.error(err)
        this.$talert('对账单下载失败，请稍后重试', '系统提示', {
          confirmButtonText: '确定'
        })
      })
    },
    // 查询
    getTableData () {
      const { formData, pageNum, pageSize } = this

      const startDate = this.formData.startDate.split('-').join('')
      const endDate = this.formData.endDate.split('-').join('')
      const monthMap = {
        '01': 'January',
        '02': 'February',
        '03': 'March',
        '04': 'April',
        '05': 'May',
        '06': 'June',
        '07': 'July',
        '08': 'August',
        '09': 'September',
        10: 'October',
        11: 'November',
        12: 'December'
      }
      // 判断是否在一年之内（365天）
      const flag = this.$_format.checkDate(this.formData.startDate, this.formData.endDate)
      if (flag !== true) {
        this.$warn(flag)
        return false
      }

      const { startDate: _startDate, endDate: _endDate } = this.formData
      const _startDateList = _startDate.split('-')
      const _endDateList = _endDate.split('-')
      this.tableLoading = true
      this.currencyType = this.formData.accountNo.split('|')[1]
      this.currencyTypeZh = this.$_params.getDisplay('GRB_CURRENCY_TYPE', this.currencyType)
      this.timeEn = `From：${monthMap[_startDateList[1]]} ${_startDateList[2]}, ${_startDateList[0]} To：${monthMap[_endDateList[1]]} ${_endDateList[2]}, ${_endDateList[0]}`
      this.timeZh = `${_startDate} 至 ${_endDate}`
      this.accountNo = formData.accountNo.split('|')[0]
      this.accountName = formData.accountNo.split('|')[2]

      return downloadBillApi.getTableData({
        ...formData,
        startDate,
        endDate,
        accountNo: formData.accountNo.split('|')[0],
        pageNum,
        pageSize
      }).then(res => {
        if (res) {
          this.tableLoading = false
          const { list, totalSize } = res
          this.tableData = list || []
          this.total = totalSize
          this.searchSuccess = true
          this.getAlias()
          this.totalPage = Math.ceil(Number(totalSize) / Number(pageSize))
        }
      }).catch(err => {
        // this.tableLoading = false
        this.searchSuccess = false
        console.error(err)
      })
    },
    // 别名
    getAlias () {
      downloadBillApi.getAlias().then(res => {
        if (res.alia) {
          const { accountNo } = this.formData
          const targetNo = accountNo.split('|')[0]

          if (res.accNo !== targetNo) {
            return false
          }
          this.alias = res.alia || ''
        }
      }).catch(err => {
        console.error(err)
      })
    },
    // 重置
    resetQuery () {
      this.$refs.queryForm.resetFields()
    },
    handleQuery () {
      this.$refs.queryForm.validate(valid => {
        if (valid) {
          this.pageNum = 1
          this.getTableData()
        }
      })
    },
    /* 分页 */
    handleSizeChange () {
      this.getTableData()
    },
    handleCurrentChange () {
      this.getTableData()
    }
  }
}
</script>

<style lang="less">
.download-bill-page {

  .bill-detail-bottom {
    display: flex;
    margin-top: 30px;
    width: 100%;

    .bill-sign {
      width: 159px;
      height: 106px;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .bill-sign-right {
      flex: 1 1 0%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .page {
        font-size: 13px;
        font-weight: 400;
        color: #A1A7C4;
        line-height: 14px;
      }

      .bill-detail-bottom-opt {
        margin-top: auto;
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        > span {
          font-size: 14px;
          font-weight: 300;
          color: #333752;
          line-height: 14px;
          margin-right: 16px;
          margin-left: 20px;
        }

        .btn140 {
          margin-left: 20px;
        }
      }
    }
  }

  .download-bill-detail {
    width: 100%;
    background: #fff;
    box-shadow: 0px 6px 20px 0px rgba(90, 96, 127, 0.1);
    border-radius: 10px;
    border: 1px solid #F6F7FC;
    padding: 40px 20px;
    margin-bottom: 40px;
    position: relative;

    .loading {
      position: absolute;
      width: 100%;
      height: 100%;
    }

    .el-table__row td {
      padding: 10px 0;
      font-size: 13px;
    }

    .detail-header {
      .split {
        height: 15px;
      }
      .detail-header-item {
        display: flex;
        align-items: center;
        margin-bottom: 5px;

        p {
          flex: 1 1 0%;
          font-size: 13px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #5A607F;
          line-height: 16px;

          &:nth-child(2) {
            display: flex;
            justify-content: flex-end;
          }
        }
      }
    }

    .detail-title {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333752;
      line-height: 30px;
      margin-bottom: 20px;
    }
  }
  .btn140 {
    min-width: 140px;
  }
  .is-group {
    tr:nth-child(1) > th {
      padding-bottom: 0;
      padding-top: 8px;
      border-bottom: 0;

      .cell {
        word-break: break-word;
      }
    }
    tr:nth-child(2) > th {
      padding-top: 0;
      padding-bottom: 8px;
    }
  }
  .download-bill-query {
    .el-form-item__label {
      display: block;
      float: inherit;
    }
  }
}

</style>
